<div class="min-h-screen flex flex-col">
  <div class="w-full xl:w-9/12 lg:w-11/12 mx-auto">
    <app-navbar class="sm:mt-10" (loading)="setLoading($event)" />
  </div>

  <div class="flex-1">
    <router-outlet />
  </div>
  
  <app-footer />
</div>
@if(loading()){
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
>
  <p-progress-spinner ariaLabel="loading" />
</div>
}
